import { axios } from '@/services/axios';

export const getTRSNodes = (clusterID) => {
    const endpoint = `/TRSNodes/${clusterID}`;
    const res = axios.get(endpoint);
    return res;
};
